import {
	ContractorDetailsItem,
	ContractorType,
	EditContractorFormData,
} from "@dune/types";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";

const editContractorSchema = z.object({
	type: z.enum(ContractorType),
	siren: z
		.string()
		.min(9, "Le SIREN doit contenir 9 chiffres")
		.max(9, "Le SIREN doit contenir 9 chiffres"),
	denomination: z.string().optional(),
	headquartersAddress: z.string().optional(),
});

export const useEditContractorForm = (contractor: ContractorDetailsItem) => {
	const form = useForm<EditContractorFormData>({
		resolver: zodResolver(editContractorSchema),
		defaultValues: {
			type: contractor.type,
			siren: contractor.society?.siren || "",
			denomination: contractor.society?.denomination || "",
			headquartersAddress: contractor.society?.headOfficeAddress
				? `${contractor.society.headOfficeAddress.streetNumber || ""} ${contractor.society.headOfficeAddress.streetName || ""} ${contractor.society.headOfficeAddress.postalCode || ""} ${contractor.society.headOfficeAddress.city || ""}`.trim()
				: "",
		},
	});

	return { form };
};
